import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'

interface Props {
  open: boolean
  initialPhone?: string
  onClose: () => void
  onConfirm: (phone: string, reason: string) => void
}

const BlockHostDialog = ({ open, initialPhone = '', onClose, onConfirm }: Props) => {
  const [phone, setPhone] = useState(initialPhone)
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (open) {
      setPhone(initialPhone)
      setReason('')
    }
  }, [open, initialPhone])

  const handleConfirm = () => {
    if (!phone.trim()) {
      return
    }
    onConfirm(phone.trim(), reason.trim())
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Заблокувати хоста?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Хост не зможе увійти та зареєструватись, а всі його оголошення потраплять до архіву
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label="Телефон"
          value={phone}
          onChange={event => setPhone(event.target.value)}
        />
        <TextField
          fullWidth
          margin="dense"
          label="Причина"
          value={reason}
          onChange={event => setReason(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Відмова</Button>
        <Button onClick={handleConfirm} color="primary" disabled={!phone.trim()} autoFocus>Заблокувати</Button>
      </DialogActions>
    </Dialog>
  )
}

export default BlockHostDialog
